export default "__VITE_ASSET__5c687c6f__"